module.exports = __webpack_public_path__ + "media/images/rank-1-2b7c2ebe1e927b194330a460fd6d8564.svg";